import { generatePassword, ListService, LocalizationService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { SubscriptionService, ABP } from '@abp/ng.core';
import { ToasterService, ConfirmationService, Confirmation } from '@abp/ng.theme.shared';
import { EXTENSIONS_IDENTIFIER } from '@abp/ng.theme.shared/extensions';
import { Store, Select } from '@ngxs/store';
import { Observable, interval } from 'rxjs';
import { GetListTerminal, EnableTerminal, DisableTerminal, DeleteTerminal, UpdateTerminal } from '../../actions/terminal-management.actions';
import { TerminalManagement } from '../../models';
import { TerminalManagementState } from '../../states/terminal-management.state';
import { TenantService, Saas, SaasTenantDto } from '@volo/abp.ng.saas';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { eTerminalManagementComponents } from '../../enums';

@Component({
	selector: 'lib-terminal-management',
	templateUrl: './terminal-management.component.html',
	styleUrls: ['./terminal-management.component.less'],
	providers: [
		ListService,
		{
			provide: EXTENSIONS_IDENTIFIER,
			useValue: eTerminalManagementComponents.TerminalManagement,
		},
	]
})
export class TerminalManagementComponent implements OnInit {

	tenants: SaasTenantDto[];
	pagedRequest: TerminalManagement.GetTerminalsRequest = {
		skipCount: 0,
		maxResultCount: 25
	} as TerminalManagement.GetTerminalsRequest;
	selectedTenantId: string;
	selectedTenant: ABP.BasicItem;

	@Select(TerminalManagementState.terminals)
	terminals$: Observable<TerminalManagement.TerminalItem[]>;
	@Select(TerminalManagementState.terminalTotalCount)
	terminalTotalCount$: Observable<number>;

	selected: TerminalManagement.TerminalItem;

	isModalVisible: boolean = false;
	modalBusy: boolean = false;
	form: FormGroup;

	constructor(
		public readonly list: ListService,
		private toasterService: ToasterService,
		private saasService: TenantService,
		private store: Store,
		private fb: FormBuilder,
		private confirmationService: ConfirmationService,
		private subscription: SubscriptionService) {

		this.selected = {} as TerminalManagement.TerminalItem;
		// this.list.maxResultCount = 10;
	}

	ngOnInit(): void {
		this.saasService.getList({ filter: '', getEditionNames: true, skipCount: 0, maxResultCount: 999 })
			.subscribe((tenantsResponse) => {
				this.tenants = tenantsResponse.items;
				this.selectedTenantId = this.tenants[0].id;
				this.selectedTenant = this.tenants[0];
				this.hookToQuery();
			});

	}

	tenantChanged() {
		setTimeout(() => {
			this.list.get();
			this.selectedTenant = this.tenants.find(x => x.id == this.selectedTenantId);
		}, 0);
	}

	buildForm() {
		this.form = this.fb.group({
			id: [this.selected.id],
			display: [this.selected.display, [Validators.required]],
			description: [this.selected.description, []]
		});
	}

	delete(id: string) {
		this.confirmationService.warn('TerminalManagement::TerminalDeletionConfirmationMessage', 'AbpIdentity::AreYouSure').subscribe(
			(status: Confirmation.Status) => {
				if (status === Confirmation.Status.confirm) {
					this.store.dispatch(new DeleteTerminal(id))
						.subscribe(() => {
							this.list.get();
						});
				}
			}
		)

	}

	private hookToQuery() {

		this.list.hookToQuery(query => {
			let q = {
				tenantId: this.selectedTenantId,
				...query
			} as TerminalManagement.GetTerminalsRequest;
			return this.store.dispatch(new GetListTerminal(q))
		}).subscribe(() => {

		});

	}

	setEnabled(machineCode: string, tenantId: string, isEnable: boolean) {

		this.store.dispatch(isEnable ? new EnableTerminal(machineCode, tenantId) : new DisableTerminal(machineCode, tenantId)).subscribe(() => {
			this.list.get();
		});
	}

	edit(selected: TerminalManagement.TerminalItem) {
		this.selected = selected;
		this.buildForm();
		this.isModalVisible = true;
	}

	save() {
		let value = this.form.value as TerminalManagement.UpdateTerminalRequest;
		this.modalBusy = true;
		this.store.dispatch(new UpdateTerminal(value))
			.pipe(finalize(() => {
				this.modalBusy = false;
				this.isModalVisible = false;
			}))
			.subscribe(() => {
				this.toasterService.success('修改成功！');

				this.list.get();
			});
	}

}
